import { PageTabType } from './../enums/page-tab-type';
import { PageSectionType } from './../enums/page-section-type';
import store from '@/store';
import { ViewType } from '../../interfaces/enums/view-type';
import { OnMounted } from '@studyportals/vue-platform';

export default class App implements OnMounted {
	public viewTypes = ViewType;

	public mounted(): void {
		window.addEventListener('load', () => {
			const currentUrl: URL = new URL(window.location.href);
			const urlParams = currentUrl.searchParams;
			const targetSection = urlParams.get('section');
			const targetTab = urlParams.get('tab');

			if (targetSection !== null) {
				store.actions.setActiveView(targetSection as PageSectionType, (targetTab as PageTabType) ?? null);
			}
		});
	}
}
